import { render } from "./OrderChat.vue?vue&type=template&id=13edb88a&ts=true"
import script from "./OrderChat.vue?vue&type=script&lang=ts"
export * from "./OrderChat.vue?vue&type=script&lang=ts"

import "./OrderChat.vue?vue&type=style&index=0&id=13edb88a&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__